import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import DataTable, { Column } from '../DataTable/index.jsx';
import Figure, { PercentFigure } from '../Figure/index.jsx';

import { getCurrentTime } from '../../Store/current-time.js';

import RestClient from '@scripts/utilities/rest-client.js';
import { HumanTimeAgo } from '@scripts/utilities/time.js';
import TimeFormat from '@scripts/utilities/time-format.js';

import ColumnLabels from '@data/nft-collections/columns.json';


var NameDetailColumn = function(props) {
  var content = (
    <span>{props.row.name}</span>
  );

  if (props.row.tooltip) {
    var overlay = (
      <Tooltip id={'nft-token-utility-overlay-' + props.row.id}>
        {props.row.tooltip}
      </Tooltip>
    );
    content = (
      <OverlayTrigger overlay={overlay}>
        {content}
      </OverlayTrigger>
    );
  }

  return (
    <th>
      {content}
    </th>
  );
};


var ValueDetailColumn = function(props) {
  return (
    <td>
      {props.row.value}
    </td>
  );
};


class NameColumn extends Column {
  get id() {
    return 'name';
  }

  get isConfigurable() {
    return false;
  }

  get DetailColumn() {
    return NameDetailColumn;
  }
}


class ValueColumn extends Column {
  get id() {
    return 'value';
  }

  get isConfigurable() {
    return false;
  }

  get DetailColumn() {
    return ValueDetailColumn;
  }
}


var columns = [
  new NameColumn(),
  new ValueColumn()
];


class NFTTokenUtility extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      name: null,
      owner: null,
      symbol: null,
      schema: null,
      totalSupply: null,
      launchDate: null,
      owners: null
    };

    this.fetchError = this.fetchError.bind(this);
    this.fetchSuccess = this.fetchSuccess.bind(this);
  }

  fetch() {
    RestClient.get('/wp-json/sbm/v1/nfts/' + this.props.id + '/token-utility/')
      .then(this.fetchSuccess)
      .catch(this.fetchError);
  }

  fetchError(error) {
    console.error('Error', error);

    this.setState({ loading: false });
  }

  fetchSuccess(response) {
    this.setState({
      loading: false,
      name: response.name,
      owner: response.owner,
      symbol: response.symbol,
      schema: response.schema,
      totalSupply: response.totalSupply,
      launchDate: response.launchDate,
      owners: response.owners
    });
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    var result = null;

    if (! this.state.loading) {
      var rows = [];

      if (this.state.name) {
        rows.push({
          id: 'name',
          name: ColumnLabels.name.name,
          tooltip: ColumnLabels.name.description,
          value: this.state.name
        });
      }
      if (this.state.owner) {
        rows.push({
          id: 'owner',
          name: ColumnLabels.owner.name,
          tooltip: ColumnLabels.owner.description,
          value: this.state.owner
        });
      }
      if (this.state.symbol) {
        rows.push({
          id: 'symbol',
          name: ColumnLabels.symbol.name,
          tooltip: ColumnLabels.symbol.description,
          value: this.state.symbol
        });
      }
      if (this.state.schema) {
        rows.push({
          id: 'schema',
          name: ColumnLabels.schema.name,
          tooltip: ColumnLabels.schema.description,
          value: this.state.schema
        });
      }
      if (this.state.totalSupply) {
        rows.push({
          id: 'totalSupply',
          name: ColumnLabels.totalSupply.name,
          tooltip: ColumnLabels.totalSupply.description,
          value: (
            <Figure amount={this.state.totalSupply} zeroIsBlank />
          )
        });
      }
      if (this.state.launchDate) {
        rows.push({
          id: 'launch',
          name: ColumnLabels.launch.name,
          tooltip: ColumnLabels.launch.description,
          value: TimeFormat(this.state.launchDate)
        });
      }
      if (this.state.launchDate && this.props.currentTime) {
        // this function can return a string that contais "ago" at the end.
        // That doesn't make sense here, so we remove it.
        var tmp = HumanTimeAgo(this.props.currentTime - this.state.launchDate);
        if (tmp.endsWith(' ago')) {
          tmp = tmp.substring(0, (tmp.length - 4));
        }
        rows.push({
          id: 'age',
          name: ColumnLabels.age.name,
          tooltip: ColumnLabels.age.description,
          value: tmp
        });
      }
      if (this.state.owners) {
        rows.push({
          id: 'owners',
          name: ColumnLabels.owners.name,
          tooltip: ColumnLabels.owners.description,
          value: (
            <Figure amount={this.state.owners} zeroIsBlank />
          )
        });
      }
      if (this.state.totalSupply && this.state.owners) {
        rows.push({
          id: 'distribution',
          name: ColumnLabels.distribution.name,
          tooltip: ColumnLabels.distribution.description,
          value: (
            <PercentFigure
              amount={this.state.owners / this.state.totalSupply * 100}
              highlightPositive={false}
              displaySign={false}
            />
          )
        });
      }

      if (rows.length) {
        result = (
          <DataTable columns={columns} rows={rows} showHeader={false} />
        );
      }
    }


    return result;
  }
}


NFTTokenUtility.propTypes = {
  id: PropTypes.number
};


var mapStateToProps = function(state) {
  return {
    currentTime: getCurrentTime(state)
  };
};


export default connect(mapStateToProps)(NFTTokenUtility);

